@import "~/styles/v1/_variables.scss";
@import "~/styles/v1/_spacing.scss";

.Tab {
  align-items: center;
  color: $system_eggplant-lightest;
  cursor: pointer;
  display: flex;
  font-size: 11px;
  font-weight: 700;
  height: 100%;
  padding: $size-S 0;
  position: relative;
  text-transform: uppercase;
  transition: all 0.3s;

  &:after {
    border-radius: $border-radius-base;
    bottom: 0;
    content: "";
    display: block;
    height: 2px;
    left: 0;
    position: absolute;
    transition: all 0.3s;
    width: 100%;
  }

  &:hover {
    color: $system_eggplant-base;

    &:after {
      background: $system_eggplant-lighter;
    }
  }

  &_active {
    color: $system_eggplant-darker;

    &:after {
      background: $system_eggplant-darker;
    }
  }

  .Pill {
    margin-left: 5px;
  }
}
